import { type FC } from 'react'
import { Modal } from '../../../components/Modal/Modal'
import { type AccountOpeningDTO } from '../../../models/AccountOpening'
import { storedOutcome } from '../domain/connectorResult'
import { type openingsCopy } from '../descriptor/stepCopy'

interface ConfirmDeleteSubmissionModalProps {
  opening: AccountOpeningDTO
  copy: ReturnType<typeof openingsCopy>
  onCancel: () => void
  onConfirm: () => void
}

export const ConfirmDeleteSubmissionModal: FC<ConfirmDeleteSubmissionModalProps> = ({ opening, copy, onCancel, onConfirm }) => {
  const referenceId = storedOutcome(opening.metadata).referenceId

  return (
    <Modal
      show
      onHide={onCancel}
      centered
      header={<h5 className='mb-0'>{copy.deleteTitle}</h5>}
      body={
        <div className='d-flex flex-column zocks-gap-0.75'>
          <p className='paragraph-medium mb-0'>{copy.deleteBody}</p>
          {referenceId ? (
            <p className='paragraph-small zocks-text-gray-600 mb-0'>
              {copy.deleteReference} {referenceId}
            </p>
          ) : null}
        </div>
      }
      showFooterActions
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
      onFooterPrimaryAction={onConfirm}
      onFooterSecondaryAction={onCancel}
    />
  )
}
